import styled from 'styled-components/macro';
import React from 'react';
import { connect } from 'react-redux';

import { Box } from 'modsy-ui-kit';

import { FEATURE_FLAGS, getFeatureFlagById } from 'shared/reducers/featureFlag';
import { showHideAdminModal } from '../../reducer';

const Button = styled(Box)`
  background-color: #ffe4e1;
  border: 1px solid red;
  color: red;
  cursor: pointer;
  padding: 4px;
  position: fixed;
  top: ${props => props.isSmallScreen ? '10px' : '17px'};
  left: 5px;
  z-index: 10000;
`; // why is z-index so high?

const ScreenInfo = styled(Box)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  color: red;
  z-index: 10000;
`;

const AdminButton = ({
  isSmallScreen,
  onClick,
  orientation,
  screenHeight,
  screenWidth,
  showScreenInfo
}) => (
  <React.Fragment>
    <Button isSmallScreen={isSmallScreen} onClick={onClick}>A</Button>

    {showScreenInfo &&
      <ScreenInfo>
        <Box>{`${screenWidth}px x ${screenHeight}px`}</Box>
        <Box>{`innerWidth: ${window.innerWidth}; clientWidth: ${document.documentElement.clientWidth}`}</Box>
        <Box>{`innerHeight: ${window.innerHeight}; clientHeight: ${document.documentElement.clientHeight}`}</Box>
        <Box>{`orientation: ${orientation}`}</Box>
      </ScreenInfo>
    }
  </React.Fragment>
);

const mapStateToProps = state => {
  const { isScreenWidthSmall, orientation, screenHeight, screenWidth } = state.device;
  return {
    isSmallScreen: isScreenWidthSmall,
    orientation,
    screenHeight,
    screenWidth,
    showScreenInfo: getFeatureFlagById({ featureId: FEATURE_FLAGS.ScreenInfoDebug, state }).enabled
  };
};

const mapDispatchToProps = dispatch => ({
  onClick () {
    dispatch(showHideAdminModal({ show: true }));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminButton);
